import LoginInForm from './LoginInForm';

export default LoginInForm;
